import {
    CART_ADD_ITEM,
    CART_ADD_ITEM_FAIL,
    CART_REMOVE_ITEM,
    CART_SAVE_SHIPPING_ADDRESS,
    CART_SAVE_PAYMENT_METHOD,
    CART_SAVE_CUSTOMIZATION,
    CART_SAVE_VOUCHER,
    CART_REMOVE_VOUCHER,
    CART_CLEAR_ITEMS
} from '../constants/cartConstants';



export function cartReducers(state = { cartItems: [], shippingAddress: {}, paymentMethod: null, customization: {}, voucherCode: null, discountAmount: 0, shippingDiscountAmount: 0, freeShippingApplied: false, error: null }, action) {
    switch (action.type) {
        case CART_ADD_ITEM:
            const item = action.payload;
            // Always add as new line item (never aggregate)
            return {
                ...state,
                cartItems: [...state.cartItems, item],
                error: null
            };
        
        case CART_ADD_ITEM_FAIL:
            return {
                ...state,
                error: action.payload
            };
        
        case CART_REMOVE_ITEM:
            // Remove by unique cartItemId instead of product
            return {
                ...state,
                cartItems: state.cartItems.filter(x => x.cartItemId !== action.payload)
            };
        case CART_SAVE_SHIPPING_ADDRESS:
            return {
                ...state,
                shippingAddress: action.payload
            };
        case CART_SAVE_PAYMENT_METHOD:
            return {
                ...state,
                paymentMethod: action.payload
            };
        case CART_SAVE_CUSTOMIZATION:
            return {
                ...state,
                customization: action.payload
            };
        case CART_SAVE_VOUCHER:
            return {
                ...state,
                voucherCode: action.payload.code,
                discountAmount: action.payload.discountAmount,
                shippingDiscountAmount: action.payload.shippingDiscountAmount || 0,
                freeShippingApplied: !!action.payload.freeShippingApplied
            };
        case CART_REMOVE_VOUCHER:
            return {
                ...state,
                voucherCode: null,
                discountAmount: 0,
                shippingDiscountAmount: 0,
                freeShippingApplied: false
            };
        case CART_CLEAR_ITEMS:
            return {
                ...state,
                cartItems: []
            };
        default:
            return state;
    }
}
export default cartReducers;